import { create, type StateCreator } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

import { AppSettings } from '@/constants/AppSettings';
import { createFAQSlice, type FAQSlice } from '@/store/slices/faqSlice';

import { type AppSlice, createAppSlice } from './slices/appSlice';
import {
  createCampaignSlice,
  type CampaignSlice,
} from './slices/campaign-slice';
import { createRouterSlice, type RouterSlice } from './slices/routerSlice';
import { createThreadsSlice, type ThreadsSlice } from './slices/threadsSlice';
import { createUserSlice, type UserSlice } from './slices/userSlice';

interface StoreType
  extends UserSlice,
    AppSlice,
    ThreadsSlice,
    RouterSlice,
    FAQSlice,
    CampaignSlice {}

/**
 * Middleware for zustand store adding devtools and
 * persisting JWT token to local storage
 */
const middleware = (f: StateCreator<StoreType>) =>
  persist(f, {
    name: `${AppSettings.prefix}_store`,
    storage: createJSONStorage(() => localStorage),
    partialize: state => ({
      user: state.user,
      accessToken: state.accessToken,
      route: state.route,
      opened: state.opened,
      popupClosed: state.popupClosed,
      threadId: state.threadId,
    }),
  });

export const useBoundStore = create<StoreType>()(
  middleware((...args) => ({
    ...createAppSlice(...args),
    ...createThreadsSlice(...args),
    ...createUserSlice(...args),
    ...createRouterSlice(...args),
    ...createFAQSlice(...args),
    ...createCampaignSlice(...args),
  })),
);
